import { SpinnerBlock } from "../common/Spinner";
import AdminUserUpsertForm from "./AdminUserUpsertForm";
import { GoBackLinkButton } from "../../components/GoBackLinkButton";
import * as authSelectors from "../auth/authSelectors";
import { routes } from "../../appRoutingHelpers";
import { useParams } from "react-router-dom";
import { useGetAdminUser, useGetOrganizations } from "../../service/api";
import { useSelector } from "react-redux";
import { useHandleFetchError } from "../../error-handler";

export const AdminUserUpsert = () => {
  const { id } = useParams<{
    id: string;
  }>();
  const organizationKeyName = useSelector(
    authSelectors.selectedOrganizationKeyName
  );
  const { data: adminUser, isLoading, error: adminUserError } = useGetAdminUser(
    organizationKeyName,
    id
  );
  const {
    data: organizations,
    isLoading: isLoadingOrganizations,
    error: organizationsError,
  } = useGetOrganizations(organizationKeyName);

  useHandleFetchError(adminUserError);
  useHandleFetchError(organizationsError);

  if (isLoading || isLoadingOrganizations) {
    return <SpinnerBlock />;
  }

  return (
    <div className="container mt-5">
      <GoBackLinkButton
        to={routes.adminUserList(organizationKeyName)}
        text="Back to all admin users"
      />
      <div className="row">
        <div className="col-12">
          <AdminUserUpsertForm
            adminUser={adminUser}
            organization={organizationKeyName}
            organizations={organizations || []}
          />
        </div>
      </div>
    </div>
  );
};
